import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import ChainedBackend, { type ChainedBackendOptions } from 'i18next-chained-backend'
import HttpBackend, { type HttpBackendOptions } from 'i18next-http-backend'
import resourcesToBackend from 'i18next-resources-to-backend'
import { initReactI18next } from 'react-i18next'
import { fallbackLng } from './resources'

const isProdLocalizationEnv = () =>
  window.location.href.includes('https://app.marqii.com') || process.env.NODE_ENV === 'production'

const defaultBackends = [
  HttpBackend,
  resourcesToBackend(
    (language: string, _namespace: string) => import(`./translations/${language}.json`),
  ),
]

// const localStorageBackendOptions: LocalStorageBackendOptions = {
//   expirationTime: 60 * 60 * 1000, // 1 hour
// }

const httpBackendOptions: HttpBackendOptions = {
  loadPath: '/locales/translations/{{lng}}.json',
  addPath: '/locales/translations/add/{{lng}}.json',
}

// const prodBackends = [LocalStorageBackend]

const backends = [...defaultBackends]
const backendOptions = [httpBackendOptions, {}]

const instance = i18next.use(ChainedBackend).use(LanguageDetector).use(initReactI18next)

instance.init<ChainedBackendOptions>({
  fallbackLng,
  debug: !isProdLocalizationEnv(),
  load: 'currentOnly',
  backend: {
    backends,
    backendOptions,
  },
  interpolation: {
    escapeValue: false,
  },
})

export default instance
